"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var color = function (_color) { return "color: " + _color + ";"; };
exports.default = (function (_a) {
    var active = _a.active;
    return function (_a) {
        var theme = _a.theme;
        return color(active ? theme.palette.inputIconColor[1] : theme.palette.inputIconColor[0]);
    };
});
